import Level from '../core/level.js'

const level = new Level({
    name: 'object_simple',
    dependencies: []
})


level.addQuestion({
    generator: function (q) {
        let jsCode = "let playerName = 'John'"
        jsCode += '\nlet playerLife = 100'
        jsCode += '\n\nplayerName'

        q.addJSCode(jsCode)
    },
    times: 1,
    errorExpected: true,
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        let jsCode = 'let player = {'
        jsCode += "\n\tname: 'John',"
        jsCode += '\n\tlife: 100'
        jsCode += '\n}'
        jsCode += '\n\nplayer.life'

        q.addJSCode(jsCode)
    },
    times: 1,
    errorExpected: true,
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        let jsCode = 'let player = {}'
        jsCode += "\n\nplayer.name = 'John'"
        jsCode += '\nplayer.life = 100'
        jsCode += '\n\nplayer.name'

        q.addJSCode(jsCode)
    },
    times: 1,
    errorExpected: true,
    timeoutTime: 15000
})


level.addQuestion({
    generator: function (q) {
        let jsCode = 'let player = {'
        jsCode += '\n\tlife: 100'
        jsCode += '\n}'
        jsCode += '\n\nplayer.life -= 10'
        jsCode += '\n\nplayer.life'

        q.addJSCode(jsCode)
    },
    times: 1,
    errorExpected: true,
    timeoutTime: 15000
})



export default level

